/** Approximate circuit/trace routes aligned to AI Brain.png (viewBox 0 0 400 400). */
export type BrainTracePath = {
  id: string;
  d: string;
  duration: number;
  begin?: number;
};

export const BRAIN_TRACE_PATHS: BrainTracePath[] = [
  // —— Outer silhouette ——
  {
    id: 'outline-left',
    d: 'M 200 54 C 168 56, 132 72, 112 102 C 88 142, 82 192, 96 238 C 118 288, 158 322, 200 328',
    duration: 5.5,
  },
  {
    id: 'outline-right',
    d: 'M 200 54 L 238 60 L 272 76 L 298 104 L 314 142 L 320 182 L 316 222 L 302 262 L 276 296 L 242 318 L 200 328',
    duration: 5.5,
    begin: 0.4,
  },
  // —— Left organic folds ——
  {
    id: 'lobe-left-upper',
    d: 'M 148 118 Q 172 138, 162 168 Q 152 192, 138 176',
    duration: 3.8,
    begin: 0.2,
  },
  {
    id: 'lobe-left-mid',
    d: 'M 128 188 Q 156 206, 148 236 Q 138 258, 122 242',
    duration: 4.2,
    begin: 1.1,
  },
  {
    id: 'lobe-left-lower',
    d: 'M 156 252 Q 178 268, 172 292 Q 164 308, 150 294',
    duration: 3.6,
    begin: 0.6,
  },
  // —— Right circuit traces ——
  {
    id: 'trace-right-horiz-top',
    d: 'M 224 108 L 292 108 L 292 138 L 256 138 L 256 158',
    duration: 3.4,
    begin: 0.3,
  },
  {
    id: 'trace-right-horiz-mid',
    d: 'M 236 178 L 304 178 L 304 208 L 268 208',
    duration: 3.2,
    begin: 0.9,
  },
  {
    id: 'trace-right-vert',
    d: 'M 268 118 L 268 268 L 248 268 L 248 228',
    duration: 4,
    begin: 1.4,
  },
  {
    id: 'trace-right-branch',
    d: 'M 248 148 L 228 148 L 228 198 L 246 198 L 246 248 L 286 248',
    duration: 3.8,
    begin: 0.5,
  },
  {
    id: 'trace-right-lower',
    d: 'M 232 238 L 298 238 L 298 272 L 262 272 L 262 298',
    duration: 3.5,
    begin: 1.8,
  },
  {
    id: 'trace-mid-spine',
    d: 'M 200 92 L 200 148 L 188 148 L 188 212 L 200 212 L 200 268',
    duration: 4.4,
    begin: 0.7,
  },
];
